import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IJob } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'acknowledgmentCandidateReceiptTemplates'


const filter = (axios: IFactoryFunctionRequest<Array<Pick<IJob, '_id' | 'display'>>, undefined>) => (options = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/filter`,
    query: options,
  })
}


const retreiveToEdit = (axios: IFactoryFunctionRequest<any, undefined>) => (templateId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/retreiveToEdit/${templateId}`,
  })
}


const createOne = (axios: IFactoryFunctionRequest<any, undefined>) => (template: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data: template,
  })
}

const updateOne = (axios: IFactoryFunctionRequest<any, undefined>) => (template: any) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${template?._id}`,
    data: template,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<any, undefined>) => (templateId: any) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${templateId}`,
  })
}


export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  createOne: createOne(useAxios(axios)),
  updateOne: updateOne(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
  retreiveToEdit: retreiveToEdit(useAxios(axios)),
})
